export const PRERENDER_STATE_KEY = '__FLYMETA_PRERENDER__'
export const PRERENDER_READY_EVENT = 'flymeta-prerender-ready'

export const isPrerender = () => {
  if (typeof window === 'undefined') return false
  const state = window[PRERENDER_STATE_KEY]
  return Boolean(state && state.enabled)
}

export const notifyPrerenderReady = () => {
  if (typeof document === 'undefined') return
  document.dispatchEvent(new Event(PRERENDER_READY_EVENT))
}
